/**
 * Sub gallery fade-up: lists with .fade-up (e.g. .sub-music-list.bottom, .sub-events-list, .sub-visuals-grid)
 * add .on to each li so they display, then add .fade when in view for opacity/transform animation.
 */
export function initSubGalleryFade(): void {
  const lists = document.querySelectorAll<HTMLUListElement>(
    '.sub-music-list.bottom.fade-up, .sub-events-list.fade-up, .sub-visuals-grid, .sub-visuals-list'
  );
  if (lists.length === 0) return;

  const observer =
    typeof IntersectionObserver !== 'undefined'
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const li = entry.target as HTMLElement;
              li.classList.add('fade');
              observer.unobserve(li);
            });
          },
          { rootMargin: '0px 0px 40px 0px', threshold: 0.1 }
        )
      : null;

  lists.forEach((ul) => {
    const items = ul.querySelectorAll<HTMLElement>('li');
    items.forEach((li, index) => {
      li.classList.add('on');
      if (observer) {
        observer.observe(li);
      } else {
        li.classList.add('fade');
      }
    });
  });
}
